import cx from "@hsl/core/utils/cx";

interface Props {
    children: React.ReactNode;
    className?: string;
    onClick?: React.MouseEventHandler;
}

const TextButton = ({ children, className, onClick }: Props) => {
    return (
        <button
            className={cx(
                "hover:text-core-blue text-dark-blue text-xs underline",
                className,
            )}
            onClick={onClick}
        >
            {children}
        </button>
    );
};

export default TextButton;
